import { jsx as n, jsxs as l, Fragment as b } from "react/jsx-runtime";
import { Label as $, Button as O, Heading as k, Accordion as h, BodyShort as w, Skeleton as x } from "@navikt/ds-react";
import c from "clsx";
import { BandageIcon as z, DocPencilIcon as A, Chat2Icon as H, EnvelopeClosedIcon as B, TasklistIcon as E, PersonGroupIcon as F, ArrowLeftIcon as R, PersonIcon as L } from "@navikt/aksel-icons";
var i = /* @__PURE__ */ ((e) => (e.Sykmeldinger = "Sykmeldinger", e.Soknader = "Søknader", e.Meldinger = "Beskjeder", e.Dialogmoter = "Dialogmøter", e.Oppfolgingsplaner = "Oppfølgingsplaner", e.DineSykmeldte = "Dine Sykmeldte", e))(i || {}), a = /* @__PURE__ */ ((e) => (e.Sykmelding = "Sykmelding", e.Soknad = "Søknad", e.Melding = "Aktivitetsvarsel", e.Dialogmote = "Dialogmøte", e.Oppfolgingsplan = "Oppfølgingsplan", e))(a || {});
function q(e) {
  return e.endsWith("s") || e.endsWith("x") ? `${e}'` : `${e}s`;
}
function T(e, t) {
  return `${q(e.split(" ")[0])} ${t}`;
}
function j(e, t) {
  switch (e) {
    case i.DineSykmeldte:
      return !1;
    case i.Sykmeldinger:
      return t === a.Sykmelding;
    case i.Soknader:
      return t === a.Soknad;
    case i.Meldinger:
      return t === a.Melding;
    case i.Dialogmoter:
      return t === a.Dialogmote;
    case i.Oppfolgingsplaner:
      return t === a.Oppfolgingsplan;
  }
}
function y(e) {
  switch (e) {
    case i.DineSykmeldte:
      throw new Error("DineSykmeldte root page has no children");
    case i.Sykmeldinger:
      return a.Sykmelding;
    case i.Soknader:
      return a.Soknad;
    case i.Meldinger:
      return a.Melding;
    case i.Dialogmoter:
      return a.Dialogmote;
    case i.Oppfolgingsplaner:
      return a.Oppfolgingsplan;
  }
}
function W(e, t, r) {
  switch (t) {
    case i.DineSykmeldte:
      return "/arbeidsgiver/sykmeldte";
    case i.Sykmeldinger:
      return `/arbeidsgiver/sykmeldte/sykmeldt/${r}/sykmeldinger`;
    case i.Soknader:
      return `/arbeidsgiver/sykmeldte/sykmeldt/${r}/soknader`;
    case i.Meldinger:
      return `/arbeidsgiver/sykmeldte/sykmeldt/${r}/meldinger`;
    case i.Dialogmoter:
      return v(e) ? `/arbeidsgiver/sykmeldte/dialogmoter/${r}` : `/syk/dialogmoter/arbeidsgiver/${r}`;
    case i.Oppfolgingsplaner:
      return v(e) ? `/arbeidsgiver/sykmeldte/oppfolgingsplaner/${r}` : `/syk/oppfolgingsplaner/arbeidsgiver/${r}`;
  }
}
function C(e) {
  switch (e) {
    case i.DineSykmeldte:
      return F;
    case i.Soknader:
    case a.Soknad:
      return E;
    case i.Meldinger:
    case a.Melding:
      return B;
    case i.Dialogmoter:
    case a.Dialogmote:
      return H;
    case i.Oppfolgingsplaner:
    case a.Oppfolgingsplan:
      return A;
    case i.Sykmeldinger:
    case a.Sykmelding:
      return z;
  }
}
function v(e) {
  switch (e) {
    case i.Sykmeldinger:
    case a.Sykmelding:
    case i.Soknader:
    case a.Soknad:
    case i.Meldinger:
    case a.Melding:
    case i.DineSykmeldte:
      return !0;
    case i.Dialogmoter:
    case i.Oppfolgingsplaner:
    case a.Dialogmote:
    case a.Oppfolgingsplan:
      return !1;
  }
}
const G = "_notifcationDot_1qo1z_1", U = "_absolute_1qo1z_16", M = {
  notifcationDot: G,
  absolute: U
};
function J({ notifications: e, tooltip: t, absolute: r }) {
  return /* @__PURE__ */ n("div", { className: c(M.notifcationDot, { [M.absolute]: r }), title: t, children: e });
}
function I({ Icon: e, childActive: t, notifications: r }) {
  return t ? /* @__PURE__ */ n(R, { role: "img", "aria-hidden": !0 }) : r > 0 ? /* @__PURE__ */ n(J, { notifications: r }) : /* @__PURE__ */ n(e, { role: "img", "aria-hidden": !0 });
}
const K = "_menuItem_1lrfp_1", Q = "_notifyingItem_1lrfp_1", V = "_activeItem_1lrfp_5", X = "_menuItemButton_1lrfp_9", s = {
  menuItem: K,
  notifyingItem: Q,
  activeItem: V,
  menuItemButton: X
}, Y = "_subMenuItem_w5ck1_1", Z = "_activeSubItem_w5ck1_1", D = {
  subMenuItem: Y,
  activeSubItem: Z
};
function N({ page: e }) {
  const t = C(e);
  return /* @__PURE__ */ n("li", { className: D.subMenuItem, children: /* @__PURE__ */ l("div", { className: c("navds-button--small", D.activeSubItem), children: [
    /* @__PURE__ */ n(t, { role: "img", "aria-hidden": !0 }),
    /* @__PURE__ */ n($, { size: "small", children: e })
  ] }) });
}
function u({ sykmeldtId: e, page: t, activePage: r, route: o }) {
  if (typeof o == "boolean" || typeof o != "number" && o.hide)
    return null;
  const _ = C(t), m = j(t, r);
  if (typeof o == "number") {
    const S = o;
    return /* @__PURE__ */ l(b, { children: [
      /* @__PURE__ */ n("li", { className: s.menuItem, children: /* @__PURE__ */ n(
        O,
        {
          className: c(s.menuItemButton, {
            [s.activeItem]: r === t,
            [s.notifyingItem]: S > 0
          }),
          href: W(r, t, e),
          as: "a",
          variant: "tertiary",
          size: "small",
          icon: /* @__PURE__ */ n(I, { Icon: _, childActive: m, notifications: S }),
          children: t
        }
      ) }),
      m && /* @__PURE__ */ n(N, { page: y(t) })
    ] });
  }
  return /* @__PURE__ */ l(b, { children: [
    /* @__PURE__ */ n("li", { className: s.menuItem, children: /* @__PURE__ */ l(
      o.internalRoute,
      {
        className: c("navds-button navds-button--tertiary navds-button--small", s.menuItemButton, {
          [s.activeItem]: r === t,
          [s.notifyingItem]: o.notifications > 0
        }),
        children: [
          /* @__PURE__ */ n("span", { className: "navds-button__icon", children: /* @__PURE__ */ n(I, { Icon: _, childActive: m, notifications: o.notifications }) }),
          /* @__PURE__ */ n("span", { className: "navds-label navds-label--small", children: t })
        ]
      }
    ) }),
    m && /* @__PURE__ */ n(N, { page: y(t) })
  ] });
}
const P = "_navRoot_1euqs_1", ee = "_heading_1euqs_5", ne = "_buttonList_1euqs_11", f = {
  navRoot: P,
  heading: ee,
  buttonList: ne
};
function Ne({ sykmeldtName: e, sykmeldtId: t, activePage: r, routes: o }) {
  return /* @__PURE__ */ l("nav", { "aria-labelledby": "side-menu-header", className: f.navRoot, children: [
    /* @__PURE__ */ n(k, { id: "side-menu-header", level: "2", size: "small", className: f.heading, children: T(e, "sideoversikt") }),
    /* @__PURE__ */ l("ul", { className: f.buttonList, children: [
      /* @__PURE__ */ n(
        u,
        {
          sykmeldtId: t,
          page: i.Sykmeldinger,
          route: o.Sykmeldinger,
          activePage: r
        }
      ),
      /* @__PURE__ */ n(
        u,
        {
          sykmeldtId: t,
          page: i.Soknader,
          route: o.Soknader,
          activePage: r
        }
      ),
      /* @__PURE__ */ n(
        u,
        {
          sykmeldtId: t,
          page: i.Dialogmoter,
          route: o.Dialogmoter,
          activePage: r
        }
      ),
      /* @__PURE__ */ n(
        u,
        {
          sykmeldtId: t,
          page: i.Oppfolgingsplaner,
          route: o.Oppfolgingsplaner,
          activePage: r
        }
      ),
      /* @__PURE__ */ n(
        u,
        {
          sykmeldtId: t,
          page: i.Meldinger,
          route: o.Meldinger,
          activePage: r
        }
      ),
      /* @__PURE__ */ n(
        u,
        {
          sykmeldtId: t,
          page: i.DineSykmeldte,
          route: o.DineSykmeldte,
          activePage: r
        }
      )
    ] })
  ] });
}
function te(e) {
  return e.replace(/(.{6})/g, "$1 ");
}
const ie = "_accordionMobileRoot_iczrb_1", re = "_accordionHeaderContent_iczrb_5", oe = "_peopleIcon_iczrb_11", ae = "_accordionContent_iczrb_18", le = "_heading_iczrb_22", p = {
  accordionMobileRoot: ie,
  accordionHeaderContent: re,
  peopleIcon: oe,
  accordionContent: ae,
  heading: le
}, se = ({
  headerTitle: e,
  sykmeldtFnr: t,
  children: r,
  className: o
}) => /* @__PURE__ */ n(h, { className: c(p.accordionMobileRoot, o), children: /* @__PURE__ */ l(h.Item, { children: [
  /* @__PURE__ */ n(h.Header, { id: `sykmeldt-accordion-header-${t}`, children: /* @__PURE__ */ l("div", { className: p.accordionHeaderContent, children: [
    /* @__PURE__ */ n(L, { className: p.peopleIcon, "aria-hidden": !0 }),
    /* @__PURE__ */ l("div", { children: [
      /* @__PURE__ */ n(k, { className: p.heading, level: "1", size: "xlarge", children: e }),
      /* @__PURE__ */ n(w, { children: te(t) })
    ] })
  ] }) }),
  /* @__PURE__ */ n(h.Content, { className: p.accordionContent, children: r })
] }) }), ce = "_headerRoot_fv5wd_1", de = "_wrapper_fv5wd_9", me = "_heading_fv5wd_19", ue = "_subtitle_fv5wd_34", ge = "_headerExtra_fv5wd_38", pe = "_hideHeaderOnMobile_fv5wd_49", g = {
  headerRoot: ce,
  wrapper: de,
  heading: me,
  subtitle: ue,
  headerExtra: ge,
  hideHeaderOnMobile: pe
};
function _e({ header: e, headerRight: t, hideHeaderOnMobile: r, children: o }) {
  return /* @__PURE__ */ l(b, { children: [
    typeof e == "object" && /* @__PURE__ */ n(
      "div",
      {
        className: c("dinesykmeldte-sidemeny__header", g.headerRoot, {
          [g.hideHeaderOnMobile]: r
        }),
        children: /* @__PURE__ */ l("section", { className: c(g.wrapper), "aria-labelledby": "page-header", children: [
          /* @__PURE__ */ l("div", { className: g.heading, children: [
            e.Icon && /* @__PURE__ */ n(e.Icon, { role: "img", "aria-hidden": !0 }),
            /* @__PURE__ */ l("div", { children: [
              /* @__PURE__ */ n(k, { id: "page-header", level: "1", size: "xlarge", children: e.title }),
              e.subtitle && /* @__PURE__ */ n(w, { className: g.subtitle, children: e.subtitle }),
              !e.subtitle && e.subtitleSkeleton && /* @__PURE__ */ n(x, { variant: "text", width: "100%", height: "var(--a-font-size-heading-xlarge)" })
            ] })
          ] }),
          t && /* @__PURE__ */ n("div", { className: g.headerExtra, children: t })
        ] })
      }
    ),
    o
  ] });
}
const he = "_rootContainer_1grw3_1", fe = "_content_1grw3_9", be = "_pageContainer_1grw3_29", ke = "_desktopMenuContainer_1grw3_36", Se = "_sideMenuFiller_1grw3_37", ye = "_mobileMenuAccordion_1grw3_42", d = {
  rootContainer: he,
  content: fe,
  pageContainer: be,
  desktopMenuContainer: ke,
  sideMenuFiller: Se,
  mobileMenuAccordion: ye
}, we = ({
  header: e,
  headerRight: t,
  sykmeldt: r,
  navigation: o,
  children: _,
  className: m
}) => /* @__PURE__ */ l(_e, { header: e, headerRight: t, hideHeaderOnMobile: !!o, children: [
  o && r ? /* @__PURE__ */ n(
    se,
    {
      headerTitle: e ? e.title : r.navn,
      sykmeldtFnr: r.fnr,
      className: d.mobileMenuAccordion,
      children: o
    }
  ) : null,
  /* @__PURE__ */ n("div", { className: c(d.rootContainer, m), children: /* @__PURE__ */ l("div", { className: d.content, children: [
    o ? /* @__PURE__ */ n("div", { className: d.desktopMenuContainer, children: o }) : /* @__PURE__ */ n("div", { className: d.sideMenuFiller }),
    /* @__PURE__ */ n("section", { className: d.pageContainer, children: _ }),
    /* @__PURE__ */ n("div", { className: d.sideMenuFiller })
  ] }) })
] });
export {
  a as ChildPages,
  J as NotifcationDot,
  we as PageContainer,
  i as RootPages,
  Ne as SideMenu
};
